/**
 * First step: choose how to fix the label-generation error. Shows the error the merchant clicked
 * Resolve on, then one card per resolution path.
 */
import { observer } from "mobx-react";
import Chip, { CHIP_COLORS } from "../../../../../../../components/chip/chip";
import FontBody1 from "../../../../../../../components/fonts/font-body1/font-body1";
import FontBody2 from "../../../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../../../../../components/fonts/font-props";
import IconInTransit from "../../../../../../../components/icons/icon-in-transit/icon-in-transit";
import IconReturnToBeSent from "../../../../../../../components/icons/icon-return-to-be-sent/icon-return-to-be-sent";
import ListLayout, { LIST_LAYOUT_SPACING_VARIANT } from "../../../../../../../components/layouts/list-layout/list-layout";
import { Note, NOTE_TYPE } from "../../../../../../../components/note/note";
import { IResolveLabelErrorScreenProps, RESOLVE_LABEL_ERROR_STEP } from "../../../../stores/rma-action-store/resolve-label-error-action-store";
import ResolveLabelErrorCard from "../../resolve-label-error-card/resolve-label-error-card";

const SelectResolutionPathScreen: React.FC<IResolveLabelErrorScreenProps> = observer(({ store }) => {
    const errorNote = store.errorNote;

    return (
        <ListLayout>
            <ListLayout spacingVariant={LIST_LAYOUT_SPACING_VARIANT.SMAll}>
                <FontBody1 color={FONT_COLOR.NEUTRAL3}>
                    We have encountered an error while generating your label:
                </FontBody1>

                {errorNote && (
                    <Note
                        type={store.ratesFailed ? NOTE_TYPE.ERROR : NOTE_TYPE.INFORMATION}
                        caption={errorNote.caption}
                        body={errorNote.body}
                    />
                )}
            </ListLayout>

            <ListLayout spacingVariant={LIST_LAYOUT_SPACING_VARIANT.SMAll}>
                <FontBody2 color={FONT_COLOR.NEUTRAL3}>
                    How do you want to resolve this issue?
                </FontBody2>

                <ResolveLabelErrorCard
                    icon={IconReturnToBeSent}
                    title="Review shipping details"
                    description="Solve error by review and validate the details on each section. Then click approve."
                    trailing={<Chip label="Recommended" color={CHIP_COLORS.BLUE} />}
                    onClick={() => store.goToStep(RESOLVE_LABEL_ERROR_STEP.VALIDATE_SHIPPING_DETAILS)}
                />

                <ResolveLabelErrorCard
                    icon={IconInTransit}
                    title="Change shipping option"
                    description="Change the shipping option by choosing different method and rate. (will change the shipping details)"
                    onClick={() => store.goToStep(RESOLVE_LABEL_ERROR_STEP.CHANGE_SHIPPING_OPTION)}
                />
            </ListLayout>
        </ListLayout>
    );
});

export default SelectResolutionPathScreen;
